// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"e7dee7bb","736":"483a74c4"}[chunkId] + ".chunk.css";
};